import { useKanban } from "components/kanban/kanban-context";
import { funcFormatCurrency } from "functions/funcFormatCurrency";
import React from "react";
import { useDispatch } from "react-redux";
import { handleShowDetail } from "store/kanbanReducer/kanbanSlice";
import { SelectStatusPlan } from ".";

const KanbanItem = props => {
	const { provided, innerRef, handleDeleteKanban, style, data } = useKanban();
	const { id, account, money, name, note, pm, statusRevenue } = data;
	const dispatch = useDispatch();
	const handleDetailKanban = () => {
		dispatch(handleShowDetail(data));
	};
	return (
		<div
			{...provided.draggableProps}
			{...provided.dragHandleProps}
			ref={innerRef}
			style={style}
			className='kanban-task-item bg-white px-3 py-3 border border-[#DDDDDD]'>
			<div className='flex items-center justify-between mb-2'>
				<div
					className='hover:text-blue-2 transition-all title text-sm font-bold cursor-pointer'
					onClick={handleDetailKanban}>
					{name}
				</div>
				<div className='kanban-edit text-gray-1 relative hover:text-blue-2 transition-all'>
					<div className='cursor-pointer flex'>
						<em className='fa-solid fa-ellipsis'></em>
					</div>
					<ul className='kanban-edit-list bg-white px-10px py-10px gap-y-1 flex flex-col absolute top-full right-0 opacity-0 transition-all invisible shadow-[0px_4px_10px_rgba(0,0,0,0.15)]'>
						<li>
							<div
								className='flex items-center gap-x-2 text-sm group'
								href=''>
								<em className='fa-solid fa-pen text-gray-1 font-sm transition-all group-hover:text-primary'></em>
								<span className='text-gray-s2'>Sửa</span>
							</div>
						</li>
						<li>
							<div
								onClick={handleDeleteKanban(id)}
								className='flex items-center gap-x-2 text-sm group'>
								<em className='fa-solid fa-trash-can text-gray-1 font-sm transition-all group-hover:text-primary'></em>
								<span className='text-gray-s2'>Xóa</span>
							</div>
						</li>
					</ul>
				</div>
			</div>
			<ul className='text-sm leading-2 mb-2'>
				<li>Acc: {account}</li>
				<li>
					Số tiền:
					<span className='text-primary font-semibold'>
						{" "}
						{funcFormatCurrency(money)}
					</span>
				</li>
				<li>PM Kỹ thuật: {account}</li>
				<li>Mô tả: {note}</li>
			</ul>
			<div className='flex flex-wrap gap-3'>
				<div className='pms-tag-ele file'>Làm hồ sơ</div>
				<div className='pms-select-progress relative flex items-center group'>
					<SelectStatusPlan
						valueStatus={statusRevenue}></SelectStatusPlan>
				</div>
			</div>
		</div>
	);
};

export default KanbanItem;
